var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsginfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16517_2059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.306 0C5.86101 0 4.44847 0.428489 3.24701 1.23128C2.04554 2.03408 1.10911 3.17512 0.556139 4.51011C0.00316554 5.84511 -0.141518 7.3141 0.140386 8.73133C0.42229 10.1486 1.11812 11.4504 2.13988 12.4721C3.16164 13.4939 4.46345 14.1897 5.88067 14.4716C7.2979 14.7535 8.76689 14.6088 10.1019 14.0559C11.4369 13.5029 12.5779 12.5665 13.3807 11.365C14.1835 10.1635 14.612 8.75099 14.612 7.306C14.6099 5.36898 13.8395 3.5119 12.4698 2.14222C11.1001 0.772535 9.24302 0.00211754 7.306 0Z",
    fill: "#003EBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38292 5.31699C7.84574 5.31699 8.22092 4.94181 8.22092 4.47899C8.22092 4.01618 7.84574 3.64099 7.38292 3.64099C6.92011 3.64099 6.54492 4.01618 6.54492 4.47899C6.54492 4.94181 6.92011 5.31699 7.38292 5.31699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30176 6.685C7.16915 6.685 7.04197 6.73768 6.9482 6.83145C6.85444 6.92521 6.80176 7.05239 6.80176 7.185V11.443C6.80176 11.5756 6.85444 11.7028 6.9482 11.7966C7.04197 11.8903 7.16915 11.943 7.30176 11.943C7.43437 11.943 7.56154 11.8903 7.65531 11.7966C7.74908 11.7028 7.80176 11.5756 7.80176 11.443V7.183C7.80123 7.05074 7.74832 6.92407 7.65461 6.83074C7.56089 6.7374 7.43402 6.685 7.30176 6.685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16517_2059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.611,
    height: 14.611,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsginfo);
export default __webpack_public_path__ + "static/media/msginfo.e3339f365dbdf327a10d414b3e8c53d1.svg";
export { ForwardRef as ReactComponent };